import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate, useParams } from 'react-router-dom';

import '../Login/styles.css';

import { LoadingIndicator } from '@components';
import { baseADM } from '@services/env-variables';
import { logaUsuarioADMRequest } from '../../store/modules/user/actions';
import { HOME } from '../../common/utils/paths';

import { useAuth } from '../Shell';

export const SimularUsuarioPage = () => {
  const paramsURL = useParams();
  const [isADM, setIsADM] = useState(false);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const auth = useAuth();
  const user = useSelector((state) => state.user);
  const ambienteURL = baseADM;

  useEffect(() => {
    if (window.location.origin.indexOf(ambienteURL) > -1 && paramsURL) {
      setIsADM(true);
      dispatch(logaUsuarioADMRequest(paramsURL));
    }
  }, [ambienteURL, dispatch, navigate, paramsURL]);

  useEffect(() => {
    if (user.matricula && window.location.origin.indexOf(ambienteURL) > -1) {
      if (user.logado === true) {
        auth.signin(user.matricula, () => {
          navigate(HOME, { replace: true });
        });
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [auth, dispatch, user.logado, user.matricula]);

  return (
    <div className="container">
      <div className="row">
        <div className="col-12 col-sm-8 col-md-6 col-lg-5 mx-auto">
          <div className="card">
            <h1 className="d-block text-center text-muted mt-32 ts-20 fw-bold">
              Simulação de usuário
            </h1>
            {isADM ? (
              <LoadingIndicator />
            ) : (
              <div className="justify-content-center ">
                <p className=" text-center ts-18 text-muted mb-32">
                  A simulação de usuário não é permitida nesse site.
                </p>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};
